import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class PlanoModel extends EntidadeBase {
    constructor() { super('plano'); }
    async sincronizar(id) { return await ApiService.post('plano/sincronizar', { id }); }
}

const instance = new PlanoModel();
export default instance;
